/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierOrganizationDto
 */
export interface SupplierOrganizationDto {
    /**
     * Organization ID
     * @type {number}
     * @memberof SupplierOrganizationDto
     */
    id: number;
    /**
     * Organization name
     * @type {string}
     * @memberof SupplierOrganizationDto
     */
    organizationName: string;
    /**
     * Commercial registration number
     * @type {string}
     * @memberof SupplierOrganizationDto
     */
    commercialNumber: string | null;
    /**
     * Tax identification number
     * @type {string}
     * @memberof SupplierOrganizationDto
     */
    taxNumber: string | null;
    /**
     * Business types array
     * @type {Array<string>}
     * @memberof SupplierOrganizationDto
     */
    businessTypes: Array<SupplierOrganizationDtoBusinessTypesEnum>;
    /**
     * Contact info ID
     * @type {number}
     * @memberof SupplierOrganizationDto
     */
    contactInfoId: number | null;
    /**
     * Contact information
     * @type {object}
     * @memberof SupplierOrganizationDto
     */
    contactInfo?: object;
    /**
     * Associated suppliers
     * @type {Array<object>}
     * @memberof SupplierOrganizationDto
     */
    users?: Array<object>;
    /**
     * Product catalog
     * @type {object}
     * @memberof SupplierOrganizationDto
     */
    productCatalog?: object;
    /**
     * Timestamp organization was created at
     * @type {Date}
     * @memberof SupplierOrganizationDto
     */
    createdAt: Date;
    /**
     * Timestamp organization was updated at
     * @type {Date}
     * @memberof SupplierOrganizationDto
     */
    updatedAt: Date;
    /**
     * Soft delete flag
     * @type {boolean}
     * @memberof SupplierOrganizationDto
     */
    disabled: boolean;
}


/**
 * @export
 */
export const SupplierOrganizationDtoBusinessTypesEnum = {
    Manufacturer: 'MANUFACTURER',
    Importer: 'IMPORTER',
    Distributor: 'DISTRIBUTOR'
} as const;
export type SupplierOrganizationDtoBusinessTypesEnum = typeof SupplierOrganizationDtoBusinessTypesEnum[keyof typeof SupplierOrganizationDtoBusinessTypesEnum];


/**
 * Check if a given object implements the SupplierOrganizationDto interface.
 */
export function instanceOfSupplierOrganizationDto(value: object): value is SupplierOrganizationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('commercialNumber' in value) || value['commercialNumber'] === undefined) return false;
    if (!('taxNumber' in value) || value['taxNumber'] === undefined) return false;
    if (!('businessTypes' in value) || value['businessTypes'] === undefined) return false;
    if (!('contactInfoId' in value) || value['contactInfoId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    return true;
}

export function SupplierOrganizationDtoFromJSON(json: any): SupplierOrganizationDto {
    return SupplierOrganizationDtoFromJSONTyped(json, false);
}

export function SupplierOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationName': json['organizationName'],
        'commercialNumber': json['commercialNumber'],
        'taxNumber': json['taxNumber'],
        'businessTypes': json['businessTypes'],
        'contactInfoId': json['contactInfoId'],
        'contactInfo': json['contactInfo'] == null ? undefined : json['contactInfo'],
        'users': json['users'] == null ? undefined : json['users'],
        'productCatalog': json['productCatalog'] == null ? undefined : json['productCatalog'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'disabled': json['disabled'],
    };
}

export function SupplierOrganizationDtoToJSON(value?: SupplierOrganizationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationName': value['organizationName'],
        'commercialNumber': value['commercialNumber'],
        'taxNumber': value['taxNumber'],
        'businessTypes': value['businessTypes'],
        'contactInfoId': value['contactInfoId'],
        'contactInfo': value['contactInfo'],
        'users': value['users'],
        'productCatalog': value['productCatalog'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'disabled': value['disabled'],
    };
}

